import { render, staticRenderFns } from "./InspectionTasks.vue?vue&type=template&id=4c59c69a&"
import script from "./InspectionTasks.vue?vue&type=script&lang=js&"
export * from "./InspectionTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports